import { Button } from 'antd'
import { useParams } from 'react-router-dom'
import { useCompleteSubject, useSubject } from '../../../hooks/useSubject'
import { SUBJECT_STATUS_ENUM } from '../../../Types'

type Props = {
  closeDrawer: () => void
}

export const CompleteStudyDrawer = ({ closeDrawer }: Props) => {
  const { projectId, siteId, subjectId } = useParams() as { projectId: string; subjectId: string; siteId: string }

  const { data: subjectData } = useSubject(projectId, subjectId)
  const { callComplete, isLoading } = useCompleteSubject(projectId, subjectId, siteId)

  const confirm = () => {
    const obj = { projectId: projectId, subjectId: subjectId }

    return callComplete(obj).then(() => {
      closeDrawer()
    })
  }

  return (
    <div className="col-12 ">
      <h5>Confirm Study Completion</h5>
      <p className="mt-3">
        Mark participant as completed in the study. Once confirmed, the participant’s device will be disabled.
      </p>
      <p className="mt-2">Please ensure device retrieval and any pending data collection are completed.</p>
      <div className="mt-4 d-flex justify-content-end">
        <Button onClick={closeDrawer}>Cancel</Button>

        <Button
          onClick={confirm}
          className="ms-2"
          type="primary"
          loading={isLoading}
          disabled={subjectData?.status === SUBJECT_STATUS_ENUM.COMPLETED}
        >
          Confirm Study Completion
        </Button>
      </div>
    </div>
  )
}
